export default __webpack_public_path__ + "static/image15-1620b0194bc1ecab4b56bdef6ae38147.jpg";